import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortRequestFormComponent } from './port-request-form.component';
import { MaterialModule } from 'src/app/shared/material/material.module';

import { ReactiveFormsModule } from '@angular/forms';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomRadioButtonModule } from 'src/app/shared/components/custom-radio-button/custom-radio-button.module';
import { PortRequestFormRoutingModule } from './port-request-form-routing.module';



@NgModule({
  declarations: [
    PortRequestFormComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CustomInputModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    CustomRadioButtonModule,
    ReactiveFormsModule,
    PortRequestFormRoutingModule
],
  exports:[
    PortRequestFormComponent
  ]
})
export class PortRequestFormModule { }
